module.exports = __webpack_public_path__ + "static/media/simplonoi-headline-webfont.dfcd28de.woff";